import { render, staticRenderFns } from "./SpielerComp.vue?vue&type=template&id=40feee16&scoped=true&"
import script from "./SpielerComp.vue?vue&type=script&lang=ts&"
export * from "./SpielerComp.vue?vue&type=script&lang=ts&"
import style0 from "./SpielerComp.vue?vue&type=style&index=0&id=40feee16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40feee16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VDialog,VIcon})
